import dayjs, { Dayjs } from 'dayjs';

import { FireCaWiseTourTag } from './types';
import { encryptTourData, fetchHash } from './utils';

const fireTourTag: FireCaWiseTourTag = require('./tourTag.js');

export const fireCaWiseTourTag = async (
  _window: Window,
  _document: Document,
  travelId: string,
  travelAmount: number,
  internationalOrDomestic: 'domestic' | 'international',
  travelTitle: string,
  departurePlace: string,
  arrivalPlace: string,
  numberOfAdalts: number,
  numberOfChildren: number,
  numberOfBabies: number,
  hotelName: string,
  withMeal: boolean,
  departureDate: Dayjs,
  arrivalDate: Dayjs,
  planId: string
) => {
  const departureDateString = departureDate.add(9, 'hour').format('YYYYMMDD');
  const arrivalDateString = arrivalDate.add(9, 'hour').format('YYYYMMDD');
  const reservationSummary = {
    reservation_type: 1,
    tour_type: internationalOrDomestic === 'domestic' ? 1 : 2,
    amount: travelAmount,
    fuel_surcharge: 0,
    tax: 0,
    currency: 'JPY',
    exchange_rate: 1,
  };
  const reservationDetail = {
    // TODO: 本当はtravel serviceのdataを使いたい。これはMST由来のdata
    item_code: planId,
    item_name: travelTitle,
    reservation_date: dayjs()
      .add(9, 'hour')
      .format('YYYYMMDD'),
    departure_date: departureDateString,
    departure_place: departurePlace,
    return_date: arrivalDateString,
    days: arrivalDate.startOf('d').diff(departureDate.startOf('d'), 'd'),
    number_of_participants: numberOfAdalts + numberOfChildren + numberOfBabies,
    number_of_adults: numberOfAdalts,
    number_of_children: numberOfChildren,
    number_of_infants: numberOfBabies,
    // NOTE(pochi-sato): 宿泊は2020/02/26現在、1つしかなく、データの粒度がおかしくなるので、1つしかない前提で作成
    destination: [
      {
        destination_name: arrivalPlace,
        arrival_date: arrivalDateString,
        accommodation_name: hotelName,
        number_of_rooms: 1,
        with_meals: withMeal ? 1 : 0,
        transportation: [],
      },
    ],
  };
  const hash = await fetchHash(travelId, 1, travelAmount);
  const [
    encryptedReservationSummary,
    encryptedReservationDetail,
  ] = await Promise.all([
    encryptTourData(reservationSummary),
    encryptTourData(reservationDetail),
  ]);

  return fireTourTag(
    _window,
    _document,
    travelId,
    hash,
    encryptedReservationSummary,
    encryptedReservationDetail
  );
};
